@if (isLoading) {
  <div class="loading loading-contained">
    <div class="loader">Loading...</div>
  </div>
}
<div class="job-panel">
  @if (job != null) {
    <div class="job-panel-head">
      <div
        class="d-flex align-items-center"
        style="justify-content: space-between"
      >
        @if (!templateManager && job?.client_company != null) {
          <div class="company-name" (click)="goToWorkspace()">
            {{ job?.client_company?.name }}
          </div>
        }
        <div class="last-updated" tooltip="Last Updated">
          <i class="feather refresh-cw"></i>
          {{
            job?.modified_date
              | amFromUtc
              | amLocal
              | amDateFormat: "MMM, Do YYYY, h:mm A"
          }}
        </div>
      </div>
      <div class="job-panel-head-wrapper">
        <div class="left">
          <div style="margin-top: 4px"></div>
          <textarea
            [autosize]="true"
            [minRows]="1"
            type="text"
            class="title"
            [(ngModel)]="job.name"
            [attr.contenteditable]="!job.is_master_template"
            (blur)="saveOrCreateByJob(job)"
            (keydown)="handleSpecialKeys('name', $event)"
            (paste)="onPaste($event)"
            [attr.placeholder]="
              !job.is_master_template ? 'Insert the job title' : ''
            "
            placeholder="Insert the job title"
            #jobName
            id="jobName"
          ></textarea>
          <div style="margin-top: 2px"></div>
          <textarea
            [autosize]="true"
            [minRows]="1"
            type="text"
            class="description"
            [(ngModel)]="job.description"
            [attr.contenteditable]="!job.is_master_template"
            (blur)="saveOrCreateByJob(job)"
            (keydown)="handleSpecialKeys('description', $event)"
            (paste)="onPaste($event)"
            #jobDescription
            id="jobDescription"
            placeholder="Insert the job description"
          ></textarea>
        </div>
        <div
          class="right"
          style="
            position: relative;
            pointer-events: all !important;
            display: flex;
          "
        >
          @if (job.related_thread != null) {
            <button
              class="btn btn-link-black px-3"
              style="font-size: 14px"
              (click)="openThread()"
            >
              <svg
                style="vertical-align: -4px"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1201_345)">
                  <path
                    d="M6.75 8.25L9 10.5L15 4.5"
                    stroke="#0075FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15 9V13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H4.5C4.10218 15 3.72064 14.842 3.43934 14.5607C3.15804 14.2794 3 13.8978 3 13.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H11.25"
                    stroke="#0075FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1201_345">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Open Thread
            </button>
          }
          @if (!templateManager && job?.uuid?.length > 5) {
            <ds-pin
              [hovering]="true"
              [type]="pinModel"
              [model]="job"
              [pin]="job.pinned_item"
              [identifier]="job?.id"
              [company]="job.client_company"
              [showAssignedTo]="true"
            />

            <!-- <div class="icon" (click)="pinJob()">
              <i
                class="tio-pin"
                [ngClass]="{
                  pinned: job?.pinned_item?.pinned_status == 1,
                  completed: job?.pinned_item?.pinned_status == 2,
                }"
              ></i>
            </div> -->
          }
          @if (job?.uuid?.length > 5) {
            <div
              class="icon position-relative"
              dropdown
              style="margin-left: 10px"
              [autoClose]="true"
            >
              <div
                id="dLabel"
                type="button"
                dropdownToggle
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="position-absolute d-flex align-items-center justify-content-center"
                style="inset: 0"
              >
                <i class="feather more-horizontal"></i>
              </div>
              <ul
                class="dropdown-menu dropdown-menu-end"
                *dropdownMenu
                aria-labelledby="dLabel"
              >
                <li class="dropdown-header" style="padding: 3px 13px">
                  {{ templateManager ? "TEMPLATE ACTIONS" : "JOB ACTIONS" }}
                </li>
                <li
                  role="menuitem"
                  (click)="
                    !templateManager
                      ? openDuplicateJobModal(duplicateJobModal, job)
                      : job.is_master_template
                        ? duplicateJob({ is_template: true }, false)
                        : openCreateJobModal(createJobModal, job)
                  "
                >
                  <a>{{
                    !templateManager
                      ? "Duplicate"
                      : job.is_master_template
                        ? "Add to Firm Templates"
                        : "Create Job"
                  }}</a>
                </li>
                @if (templateManager && job.is_master_template) {
                  <li
                    role="menuitem"
                    (click)="openCreateJobModal(createJobModal, job)"
                  >
                    <a>Create Job</a>
                  </li>
                }
                @if (templateManager && !job.is_master_template) {
                  <li
                    role="menuitem"
                    (click)="
                      duplicateJob({ is_template: true }, !templateManager)
                    "
                  >
                    <a>Duplicate Template</a>
                  </li>
                }
                @if (!templateManager) {
                  <li
                    role="menuitem"
                    (click)="duplicateJob({ is_template: true }, false)"
                  >
                    <a>Save as Template</a>
                  </li>
                }
                @if (!templateManager) {
                  <li role="menuitem" (click)="openHistoryModal(job.uuid)">
                    <a>History</a>
                  </li>
                }
                @if (
                  !job.is_master_template &&
                  (userPermissions?.role == ROLE_ADMIN ||
                    userPermissions.permissions.includes(
                      PERMISSION_JOBS_JOB_DELETE
                    ))
                ) {
                  <li
                    role="menuitem"
                    (click)="
                      !templateManager
                        ? openRemoveJobModal(removeJobModal, job)
                        : openRemoveJobModal(removeTemplateModal, job)
                    "
                  >
                    <a>{{
                      templateManager
                        ? "Delete Template!"
                        : "Delete Entire Job!"
                    }}</a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <div
    name="job-settings"
    class="job-settings"
    [ngStyle]="job?.is_master_template ? { 'border-bottom': '0' } : {}"
  >
    <div class="row">
      <!-- parent row -->
      <div class="col-md-6">
        <!-- parent left-column -->
        <div class="row">
          <div class="col-md-5">
            @if (jobsStore.company.accountants != null) {
              <div class="form-group assignee-wrapper">
                <label>Assigned To</label>
                <div
                  class="assignee"
                  dropdown
                  [autoClose]="true"
                  dropdownToggle
                >
                  <div class="avatar">
                    <img
                      [src]="
                        job.assigned_to?.pictureUrl ??
                        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                      "
                    />
                  </div>
                  <div
                    class="username"
                    [tooltip]="
                      job.assigned_to == null
                        ? 'Assign to'
                        : job.assigned_to?.full_name
                    "
                    placement="top"
                  >
                    {{
                      job.assigned_to == null
                        ? "Assign to"
                        : job.assigned_to?.full_name
                    }}
                  </div>
                  <ul
                    id="basic-link-dropdown"
                    *dropdownMenu
                    class="dropdown-menu"
                    role="menu"
                    aria-labelledby="basic-link"
                  >
                    @for (accountant of _accountants; track accountant) {
                      <li (click)="selectAssignee(accountant)">
                        <a>
                          <div class="avatar">
                            <img
                              [src]="
                                accountant.user.pictureUrl ??
                                'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                              "
                            />
                          </div>
                          <div
                            class="username"
                            [tooltip]="accountant.user.full_name"
                            placement="top"
                          >
                            {{ accountant.user.full_name }}
                          </div>
                        </a>
                      </li>
                    }
                  </ul>
                  <i class="feather chevron-down"></i>
                </div>
                <div class="assignee-dropdown">
                  <div class="search-wrapper">
                    <input
                      type="text"
                      class="search"
                      placeholder="Search staff"
                    />
                  </div>
                </div>
              </div>
            }
          </div>

          @if (!job?.is_master_template) {
            <div class="col-md-3">
              <div class="form-group">
                <label>Urgency</label>
                <div class="switch-toggle">
                  <div class="toggle-wrapper">
                    <div class="toggle">
                      <input
                        type="checkbox"
                        name="urgent"
                        (change)="saveOrCreateByJob(job)"
                        [disabled]="job.is_master_template"
                        [(ngModel)]="job.urgent"
                        class="check urgent"
                      />
                      <b class="b switch"></b>
                      <b class="b track"></b>
                    </div>
                  </div>
                  <span>Urgent</span>
                </div>
              </div>
            </div>
          }

          <div class="col-md-3">
            <div class="form-group" style="margin-bottom: 0">
              <label class="d-flex align-items-center"
                >Repeat &nbsp;&nbsp;
                @if (job.recurring) {
                  <span
                    (click)="openRepeatModal(repeatModal)"
                    style="cursor: pointer"
                  >
                    <svg
                      width="42"
                      height="18"
                      viewBox="0 0 42 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.75 11.0476L15.15 10.5526C14.9706 10.4036 14.8284 10.2149 14.7346 10.0014C14.6409 9.78789 14.5982 9.55546 14.61 9.32258C14.61 9.21758 14.61 9.10508 14.61 9.00008C14.61 8.89508 14.61 8.78258 14.61 8.67758C14.5982 8.44469 14.6409 8.21226 14.7346 7.99875C14.8284 7.78524 14.9706 7.59652 15.15 7.44758L15.75 6.95258C15.8879 6.84078 15.9816 6.68372 16.0146 6.50931C16.0475 6.33491 16.0176 6.15447 15.93 6.00008L15.06 4.50008C14.9707 4.34834 14.8308 4.23288 14.6649 4.17392C14.4989 4.11495 14.3176 4.11625 14.1525 4.17758L13.4025 4.44758C13.1842 4.52916 12.9499 4.55876 12.7182 4.53403C12.4864 4.50929 12.2637 4.4309 12.0675 4.30508C11.8912 4.18327 11.7056 4.07544 11.5125 3.98258C11.3044 3.87584 11.1241 3.72192 10.9861 3.53309C10.848 3.34427 10.7561 3.12578 10.7175 2.89508L10.59 2.14508C10.5613 1.96761 10.4697 1.80637 10.332 1.69074C10.1944 1.5751 10.0198 1.51276 9.84 1.51508H8.115C7.93523 1.51276 7.76062 1.5751 7.62296 1.69074C7.48529 1.80637 7.39375 1.96761 7.365 2.14508L7.2375 2.89508C7.20216 3.12295 7.11476 3.33961 6.98208 3.52822C6.8494 3.71683 6.67503 3.87231 6.4725 3.98258C6.27938 4.07544 6.09381 4.18327 5.9175 4.30508C5.72134 4.4309 5.49856 4.50929 5.26683 4.53403C5.03511 4.55876 4.8008 4.52916 4.5825 4.44758L3.8325 4.17758C3.66936 4.12019 3.4914 4.12095 3.32876 4.17972C3.16611 4.23849 3.02878 4.35167 2.94 4.50008L2.07 6.00008C1.98245 6.15447 1.95248 6.33491 1.98544 6.50931C2.0184 6.68372 2.11214 6.84078 2.25 6.95258L2.85 7.44758C3.02942 7.59652 3.17165 7.78524 3.26539 7.99875C3.35912 8.21226 3.40179 8.44469 3.39 8.67758C3.39 8.78258 3.39 8.89508 3.39 9.00008C3.39 9.10508 3.39 9.21758 3.39 9.32258C3.40179 9.55546 3.35912 9.78789 3.26539 10.0014C3.17165 10.2149 3.02942 10.4036 2.85 10.5526L2.25 11.0476C2.11214 11.1594 2.0184 11.3164 1.98544 11.4908C1.95248 11.6652 1.98245 11.8457 2.07 12.0001L2.94 13.5001C3.02934 13.6518 3.16923 13.7673 3.33515 13.8262C3.50107 13.8852 3.68244 13.8839 3.8475 13.8226L4.5975 13.5526C4.8158 13.471 5.05011 13.4414 5.28183 13.4661C5.51356 13.4909 5.73634 13.5693 5.9325 13.6951C6.10881 13.8169 6.29438 13.9247 6.4875 14.0176C6.69563 14.1243 6.87591 14.2782 7.01395 14.4671C7.15198 14.6559 7.24395 14.8744 7.2825 15.1051L7.41 15.8551C7.43875 16.0325 7.53029 16.1938 7.66795 16.3094C7.80562 16.4251 7.98023 16.4874 8.16 16.4851H9.885C10.0648 16.4874 10.2394 16.4251 10.377 16.3094C10.5147 16.1938 10.6063 16.0325 10.635 15.8551L10.7625 15.1051C10.8011 14.8744 10.893 14.6559 11.0311 14.4671C11.1691 14.2782 11.3494 14.1243 11.5575 14.0176C11.7506 13.9247 11.9362 13.8169 12.1125 13.6951C12.3087 13.5693 12.5314 13.4909 12.7632 13.4661C12.9949 13.4414 13.2292 13.471 13.4475 13.5526L14.1975 13.8226C14.3567 13.8724 14.5279 13.8677 14.6841 13.8093C14.8403 13.7509 14.9726 13.6421 15.06 13.5001L15.93 12.0001C16.0176 11.8457 16.0475 11.6652 16.0146 11.4908C15.9816 11.3164 15.8879 11.1594 15.75 11.0476V11.0476ZM9 11.2501C8.55499 11.2501 8.11998 11.1181 7.74997 10.8709C7.37996 10.6236 7.09157 10.2722 6.92127 9.86111C6.75097 9.44998 6.70642 8.99758 6.79323 8.56112C6.88005 8.12467 7.09434 7.72375 7.40901 7.40909C7.72368 7.09442 8.12459 6.88013 8.56105 6.79331C8.99751 6.70649 9.44991 6.75105 9.86104 6.92135C10.2722 7.09164 10.6236 7.38003 10.8708 7.75004C11.118 8.12005 11.25 8.55507 11.25 9.00008C11.25 9.59681 11.0129 10.1691 10.591 10.5911C10.169 11.013 9.59674 11.2501 9 11.2501Z"
                        fill="#0075FF"
                      />
                      <path
                        d="M22.6121 5.98009V8.08009H25.4321V9.41209H22.6121V11.6321H25.7921V13.0001H20.9321V4.61209H25.7921V5.98009H22.6121ZM26.6469 9.65209C26.6469 8.98009 26.7789 8.38409 27.0429 7.86409C27.3149 7.34409 27.6829 6.94409 28.1469 6.66409C28.6109 6.38409 29.1269 6.24409 29.6949 6.24409C30.1269 6.24409 30.5389 6.34009 30.9309 6.53209C31.3229 6.71609 31.6349 6.96409 31.8669 7.27609V4.12009H33.5709V13.0001H31.8669V12.0161C31.6589 12.3441 31.3669 12.6081 30.9909 12.8081C30.6149 13.0081 30.1789 13.1081 29.6829 13.1081C29.1229 13.1081 28.6109 12.9641 28.1469 12.6761C27.6829 12.3881 27.3149 11.9841 27.0429 11.4641C26.7789 10.9361 26.6469 10.3321 26.6469 9.65209ZM31.8789 9.67609C31.8789 9.26809 31.7989 8.92009 31.6389 8.63209C31.4789 8.33609 31.2629 8.11209 30.9909 7.96009C30.7189 7.80009 30.4269 7.72009 30.1149 7.72009C29.8029 7.72009 29.5149 7.79609 29.2509 7.94809C28.9869 8.10009 28.7709 8.32409 28.6029 8.62009C28.4429 8.90809 28.3629 9.25209 28.3629 9.65209C28.3629 10.0521 28.4429 10.4041 28.6029 10.7081C28.7709 11.0041 28.9869 11.2321 29.2509 11.3921C29.5229 11.5521 29.8109 11.6321 30.1149 11.6321C30.4269 11.6321 30.7189 11.5561 30.9909 11.4041C31.2629 11.2441 31.4789 11.0201 31.6389 10.7321C31.7989 10.4361 31.8789 10.0841 31.8789 9.67609ZM35.8237 5.56009C35.5277 5.56009 35.2797 5.46809 35.0797 5.28409C34.8877 5.09209 34.7917 4.85609 34.7917 4.57609C34.7917 4.29609 34.8877 4.06409 35.0797 3.88009C35.2797 3.68809 35.5277 3.59209 35.8237 3.59209C36.1197 3.59209 36.3637 3.68809 36.5557 3.88009C36.7557 4.06409 36.8557 4.29609 36.8557 4.57609C36.8557 4.85609 36.7557 5.09209 36.5557 5.28409C36.3637 5.46809 36.1197 5.56009 35.8237 5.56009ZM36.6517 6.35209V13.0001H34.9717V6.35209H36.6517ZM40.0275 7.73209V10.9481C40.0275 11.1721 40.0795 11.3361 40.1835 11.4401C40.2955 11.5361 40.4795 11.5841 40.7355 11.5841H41.5155V13.0001H40.4595C39.0435 13.0001 38.3355 12.3121 38.3355 10.9361V7.73209H37.5435V6.35209H38.3355V4.70809H40.0275V6.35209H41.5155V7.73209H40.0275Z"
                        fill="#0075FF"
                      />
                    </svg>
                  </span>
                }
              </label>
              <div class="switch-toggle">
                <div class="toggle-wrapper">
                  <div class="toggle">
                    <input
                      type="checkbox"
                      class="check"
                      name="repeat"
                      (change)="
                        job.recurring
                          ? openRepeatModal(repeatModal)
                          : saveOrCreateByJob(job)
                      "
                      [(ngModel)]="job.recurring"
                      [disabled]="job.is_master_template"
                    />
                    <b class="b switch"></b>
                    <b class="b track"></b>
                  </div>
                </div>
                <span>Repeat</span>
              </div>
            </div>
            <!-- <div class="next-repeat" *ngIf="job.recurring">
            <button
              class="btn btn-primary btn-xs"
              (click)="openRepeatModal(repeatModal)"
              >
              Edit rules
            </button>
          </div> -->
          </div>

          @if (!templateManager) {
            <div class="col-md-12">
              <div class="form-group">
                <label style="margin-top: 16px">STATUS</label>
                <div style="margin-top: 2px">
                  <label class="radio-inline status">
                    <input
                      type="radio"
                      [(ngModel)]="job.status"
                      (change)="saveOrCreateByJob(job)"
                      [checked]="job.status == 0"
                      name="statusRadio"
                      id="statusRadio0"
                      [value]="0"
                    />
                    Not Started
                  </label>
                  <label class="radio-inline status in-progress">
                    <input
                      type="radio"
                      [(ngModel)]="job.status"
                      (change)="saveOrCreateByJob(job)"
                      [checked]="job.status == 1"
                      name="statusRadio"
                      id="statusRadio1"
                      [value]="1"
                    />
                    In Progress
                  </label>
                  <label class="radio-inline status on-hold">
                    <input
                      type="radio"
                      [(ngModel)]="job.status"
                      (change)="saveOrCreateByJob(job)"
                      [checked]="job.status == 2"
                      name="statusRadio"
                      id="statusRadio2"
                      [value]="2"
                    />
                    On Hold
                  </label>
                  <label class="radio-inline status completed">
                    <input
                      type="radio"
                      [(ngModel)]="job.status"
                      (change)="saveOrCreateByJob(job)"
                      [checked]="job.status == 3"
                      name="statusRadio"
                      id="statusRadio3"
                      [value]="3"
                    />
                    Completed
                  </label>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- parent left-column -->
      <div class="col-md-6">
        <!-- parent right-column -->
        <div class="row">
          <div class="col-md-12">
            @if (!templateManager) {
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Start date</label>
                    <p-datepicker
                      [(ngModel)]="job.target_start_date"
                      (onSelect)="
                        selectDate(
                          $event,
                          job.target_start_date,
                          'target_start_date'
                        )
                      "
                      [dateFormat]="datepickerFormat"
                      [disabled]="
                        userPermissions?.role != ROLE_ADMIN &&
                        !userPermissions.permissions.includes(
                          PERMISSION_JOBS_JOB_EDIT_DATE
                        )
                      "
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Due date</label>
                    <p-datepicker
                      [(ngModel)]="job.due_date"
                      (onSelect)="selectDate($event, job.due_date, 'due_date')"
                      [dateFormat]="datepickerFormat"
                      [disabled]="
                        userPermissions?.role != ROLE_ADMIN &&
                        !userPermissions.permissions.includes(
                          PERMISSION_JOBS_JOB_EDIT_DATE
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            }
            <div class="row">
              <div class="col-md-12">
                <div>
                  <label
                    style="
                      font-weight: 700;
                      font-size: 13px;
                      text-transform: uppercase;
                      color: #151c29;
                      display: block;
                      margin-bottom: 4px;
                    "
                    >TAGS</label
                  >
                  @for (tag of job.tags; track tag) {
                    <ch-tag
                      [name]="tag.name"
                      [color]="tag.color"
                      [canRemove]="true"
                      (remove)="removeTagFromJob(tag)"
                    ></ch-tag>
                  }
                  <ch-tag-add
                    [job]="job"
                    (tagClick)="addTagToJob($event)"
                    [existingTags]="job.tags"
                  ></ch-tag-add>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- parent right-column -->
    </div>
    <!-- parent row -->
  </div>

  @if (job.task_groups?.length > 0) {
    <div name="job-form" class="job-form">
      <div class="row no-shrink">
        <div
          class="col-lg-6 d-flex flex-column task-list-panel"
          style="flex-shrink: 0; flex-basis: 50%; height: 100%"
        >
          <!-- Job Tasks List -->
          <div
            class="left-form"
            (click)="!job.is_master_template && addTaskPanel($event)"
          >
            <div class="task-list">
              <div
                class="form-group"
                style="margin-bottom: 0; display: flex; align-items: center"
              >
                <!-- <label style="flex-grow: 1;">Task list</label> -->
                @if (isAutopilotAvailable()) {
                  <div
                    class="autopilot"
                    style="display: flex; align-items: center; padding: 6px"
                  >
                    <div class="switch-toggle">
                      <div class="toggle-wrapper">
                        <div class="toggle">
                          <input
                            type="checkbox"
                            name="autopilot"
                            (change)="toggleAutopilot(autoPilotModal)"
                            class="check autopilot"
                            [(ngModel)]="autopilot"
                          />
                          <b class="b switch"></b>
                          <b class="b track"></b>
                        </div>
                      </div>
                      <span style="font-weight: 600">Autopilot</span>
                    </div>
                    @if (autopilot) {
                      <i
                        class="feather settings"
                        style="cursor: pointer; padding: 6px"
                        (click)="openAutoPilotModal(autoPilotModal)"
                      ></i>
                    }
                  </div>
                }
                <ng-template #autoPilotModal>
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      (click)="bsModalRef.hide()"
                      aria-label="Close"
                    >
                      <i class="feather x"></i>
                    </button>
                    <h4 class="modal-title">Autopilot Settings</h4>
                  </div>
                  <div class="modal-body">
                    <h4>Auto-Send</h4>
                    <p>
                      <span style="padding: 10px"
                        >Send Client Tasks (that are at start of job)</span
                      >
                      <select
                        (change)="setAutopilotIn($event.target.value)"
                        [(ngModel)]="autopilotIn"
                        name="autopilotIn"
                        style="width: 70px; display: inline"
                        id="recurrence_weekly_weeks"
                        class="form-control"
                      >
                        <option value="0">0</option>
                        <option value="1" selected>1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                        <option value="18">18</option>
                        <option value="19">19</option>
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                        <option value="31">31</option>
                      </select>
                      <span style="padding: 10px"
                        >days before job start date.</span
                      >
                    </p>
                  </div>
                  <div class="modal-footer">
                    <div class="row">
                      <div class="col-md-6 text-left">
                        <button
                          class="btn btn-default"
                          aria-label="Cancel"
                          (click)="bsModalRef.hide()"
                        >
                          Cancel
                        </button>
                      </div>
                      <div class="col-md-6 text-right">
                        <button
                          class="btn btn-primary"
                          (click)="forceSaveAutopilot(bsModalRef)"
                          [disabled]="!autopilotIn"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
              <div
                dragula="TASK_GROUPS"
                class="task-groups"
                [(dragulaModel)]="job.task_groups"
              >
                @for (
                  task_group of job.task_groups;
                  track task_group.uuid;
                  let isLast = $last
                ) {
                  <div
                    class="task-group"
                    [ngClass]="{
                      selected: selectedElement?.uuid == task_group.uuid,
                    }"
                    id="{{ task_group.id }}"
                  >
                    <div
                      class="task-item separator"
                      (click)="setSelectedElement(task_group, 'taskgroup')"
                    >
                      <div class="drag-handle drag-handle-taskgroup"></div>
                      @if (task_group != null) {
                        <div
                          class="task-title"
                          (keydown)="handleTaskPress($event, task_group, null)"
                          (blur)="
                            task_group.name = $event.target.innerText;
                            saveOrCreateTaskGroup(task_group)
                          "
                          (click)="setSelectedElement(task_group, 'taskgroup')"
                          [attr.contenteditable]="!job.is_master_template"
                          (paste)="onPaste($event)"
                          placeholder="Enter task group name"
                          #taskEl
                          id="task-{{ task_group.uuid }}"
                        >
                          {{ task_group.name }}
                        </div>
                      }
                      @if (
                        jobsStore.company.accountants != null &&
                        !templateManager
                      ) {
                        <div class="assignee-wrapper out-of-header">
                          <div
                            class="assignee"
                            dropdown
                            [autoClose]="true"
                            dropdownToggle
                            container="body"
                            [dropup]="isLast"
                          >
                            @if (task_group.owner != null) {
                              <div class="avatar">
                                <img
                                  [src]="
                                    task_group?.owner?.pictureUrl ??
                                    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                                  "
                                />
                              </div>
                            }
                            <div
                              class="username"
                              [tooltip]="
                                task_group?.owner == null
                                  ? 'Assign to'
                                  : task_group?.owner?.full_name
                              "
                              placement="top"
                            >
                              {{
                                task_group?.owner == null
                                  ? "Assign to"
                                  : task_group?.owner?.full_name
                              }}
                            </div>
                            <ul
                              id="basic-link-dropdown"
                              *dropdownMenu
                              class="dropdown-menu"
                              role="menu"
                              aria-labelledby="basic-link"
                              style="
                                max-height: 200px;
                                overflow: auto;
                                margin-left: -93px;
                                margin-top: 4px;
                              "
                            >
                              @for (
                                accountant of _accountants;
                                track accountant
                              ) {
                                <li
                                  (click)="
                                    selectTaskGroupOwner(
                                      task_group,
                                      accountant.user
                                    )
                                  "
                                >
                                  <a
                                    style="
                                      display: flex;
                                      align-items: center;
                                      gap: 4px;
                                    "
                                  >
                                    <div
                                      class="avatar"
                                      style="width: 22px; height: 22px"
                                    >
                                      <img
                                        [src]="
                                          accountant.user.pictureUrl ??
                                          'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                                        "
                                        style="
                                          width: 22px;
                                          height: 22px;
                                          object-fit: cover;
                                        "
                                      />
                                    </div>
                                    <div
                                      class="username"
                                      [tooltip]="accountant.user.full_name"
                                      placement="top"
                                    >
                                      {{ accountant.user.full_name }}
                                    </div>
                                  </a>
                                </li>
                              }
                              <li role="separator" class="divider"></li>
                              <li
                                class="remove-task-group"
                                (click)="selectTaskGroupOwner(task_group, null)"
                                style="padding: 2px 13px; cursor: pointer"
                              >
                                <i class="feather x"></i> &nbsp; Remove
                              </li>
                            </ul>
                            <i class="feather chevron-down"></i>
                          </div>
                        </div>
                      }
                      <div
                        class="early-due"
                        (click)="openDateOffsetModal(task_group)"
                      >
                        <i
                          [ngClass]="
                            task_group.due_date
                              ? 'tio-calendar'
                              : 'tio-add_event'
                          "
                        ></i>
                        @if ([undefined, null].includes(task_group.due_date)) {
                          Due Date
                        } @else {
                          {{
                            calculateDueDate(job.due_date, task_group.due_date)
                              | amDateFormat: "MMM, Do YYYY"
                          }}
                        }
                        @if (job.current_group === task_group.name) {
                          <i
                            class="tio-poi current"
                            tooltip="Current Group"
                          ></i>
                        } @else {
                          <i
                            class="tio-poi"
                            tooltip="Click to set this as Current Group"
                            (click)="setCurrentGroup($event, task_group)"
                          ></i>
                        }
                      </div>
                    </div>
                    <div dragula="TASKS" [(dragulaModel)]="task_group.tasks">
                      @for (task of task_group.tasks; track task.uuid) {
                        <div
                          class="task-item"
                          (click)="setSelectedElement(task, 'task', task_group)"
                          [ngClass]="{
                            selected: selectedElement?.uuid == task.uuid,
                            done: task?.completed,
                          }"
                        >
                          @if (task?.uuid.length > 10) {
                            <div class="drag-handle drag-handle-task"></div>
                          }
                          @if (task.related_tracked_item?.uuid) {
                            <div>
                              <label
                                style="border-radius: 500px"
                                class="status text-uppercase {{
                                  task.related_tracked_item?.answer_status
                                }}"
                              >
                                {{ task.related_tracked_item?.answer_status }}
                              </label>
                            </div>
                          }
                          @if (
                            !task.related_tracked_item && task?.uuid.length > 10
                          ) {
                            <label class="task-checkbox">
                              <input
                                type="checkbox"
                                [checked]="task.completed == true"
                                (change)="changeTaskStatus(task, task_group)"
                                id="taskCheckBox-{{ task.uuid }}"
                                value="option1"
                              />
                              <div
                                class="custom-checkbox"
                                [ngClass]="{
                                  'green-checkbox': jobTasksCompleted,
                                }"
                              ></div>
                            </label>
                          }
                          @if (task) {
                            <textarea
                              class="subtask"
                              [autosize]="true"
                              [minRows]="1"
                              [maxRows]="2.2"
                              type="text"
                              class="task-title subtask"
                              [(ngModel)]="task.name"
                              ngDefaultControl
                              (click)="
                                setSelectedElement(task, 'task', task_group)
                              "
                              #taskEl
                              id="task-{{ task.uuid }}"
                              (blur)="saveOrCreateTask(task_group, task)"
                              (keydown)="
                                handleTaskPress($event, task_group, task)
                              "
                              [attr.contenteditable]="!job.is_master_template"
                              (paste)="onPaste($event)"
                              placeholder="Enter task, or / for client task, or # for task group"
                            ></textarea>
                          }
                          <div class="task-details-indicator">
                            <i class="feather chevron-right"></i>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="task-item add-items">
                      <div (click)="addEmptyTask(task_group)">
                        <div style="padding: 4px">
                          <i class="feather plus"></i> Task
                        </div>
                      </div>
                      <div (click)="launchTrackedItemsModal(task_group)">
                        <div style="padding: 4px">
                          <i class="feather plus"></i> Client task
                        </div>
                      </div>
                      <div (click)="addEmptyTaskGroup(task_group)">
                        <div style="padding: 4px">
                          <i class="feather plus"></i> Group
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        @if (
          selectedElement &&
          !selectedElement.related_tracked_item &&
          selectedElement.uuid.length > 10
        ) {
          <div
            class="col-lg-6 d-flex"
            style="flex-shrink: 0; flex-basis: 50%; height: 100%"
          >
            <div class="task-panel">
              <div class="task-panel-head">
                <div class="left">
                  <div
                    class="title"
                    [attr.contenteditable]="false"
                    ngDefaultControl
                    [(ngModel)]="selectedElement.name"
                    (keypress)="keyHandler($event)"
                    (paste)="onPaste($event)"
                    placeholder="Insert the task title"
                    (blur)="
                      selectedElement.type == 'task'
                        ? onBlur(selectedElement, task_group)
                        : onBlur(selectedElement)
                    "
                  >
                    {{ selectedElement?.name }}
                  </div>
                </div>
                <div class="right" style="position: relative">
                  @if (selectedElement.type == "task") {
                    <div
                      class="icon"
                      dropdown
                      [autoClose]="true"
                      [insideClick]="true"
                    >
                      <span
                        id="taskDropdownActions"
                        type="button"
                        dropdownToggle
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="feather more-horizontal"></i>
                      </span>
                      <ul
                        *dropdownMenu
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="taskDropdownActions"
                      >
                        <li class="dropdown-header" style="padding: 3px 13px">
                          TASK ACTIONS
                        </li>
                        <li
                          role="menuitem"
                          (click)="openRemoveTaskModal(removeTaskModal)"
                        >
                          <a>Remove</a>
                        </li>
                      </ul>
                    </div>
                  }
                  @if (selectedElement.type == "taskgroup") {
                    <div
                      class="icon"
                      dropdown
                      [autoClose]="true"
                      [insideClick]="true"
                    >
                      <span
                        id="taskDropdownActions"
                        type="button"
                        dropdownToggle
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="feather more-horizontal"></i>
                      </span>
                      <ul
                        *dropdownMenu
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="taskDropdownActions"
                      >
                        <li class="dropdown-header" style="padding: 3px 13px">
                          TASK GROUP ACTIONS
                        </li>
                        <li
                          role="menuitem"
                          (click)="
                            openRemoveTaskGroupModal(removeTaskGroupModal)
                          "
                        >
                          <a>Remove</a>
                        </li>
                      </ul>
                    </div>
                  }
                </div>
              </div>
              <!-- TODO: Christian plz fix -->
              @if (selectedElement?.related_message) {
                <div style="margin-top: 10px; margin-bottom: 10px">
                  <message-bubble
                    [message]="selectedElement.related_message"
                    [user]="user"
                    [disabled]="true"
                  ></message-bubble>
                </div>
              }

              <p-editor
                [(ngModel)]="selectedElement.description"
                [style]="{ height: '320px' }"
                (onInit)="pEditorOnInit($event, selectedElement, task_group)"
                (onTextChange)="
                  onEditorTextChange($event, selectedElement, task_group)
                "
              >
                <p-header>
                  <span class="ql-formats">
                    <select class="ql-font ql-picker">
                      <option selected>Sans Serif</option>
                      <option value="serif">Serif</option>
                      <option value="monospace">Monospace</option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button
                      class="ql-underline"
                      aria-label="Underline"
                    ></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                  <span class="ql-formats">
                    <select
                      title="Text Color"
                      class="ql-color"
                      defaultValue="rgb(0, 0, 0)"
                    ></select>
                    <span class="ql-format-separator"></span>
                    <select
                      title="Background Color"
                      class="ql-background"
                      defaultValue="rgb(255, 255, 255)"
                    ></select>
                  </span>
                  <span class="ql-formats">
                    <button
                      class="ql-list"
                      value="ordered"
                      type="button"
                    ></button>
                    <button
                      class="ql-list"
                      value="bullet"
                      type="button"
                    ></button>
                  </span>
                  <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Image" class="ql-image"></button>
                  </span>
                </p-header>
              </p-editor>

              <div
                class="mt-2 text-sm d-flex align-items-center gap-2"
                style="height: 22px"
              >
                <span>
                  Last saved:
                  {{
                    selectedElement?.modified_date
                      | amFromUtc
                      | amLocal
                      | amDateFormat: "MMM, Do YYYY, h:mm A"
                  }}
                </span>
                @if (selectedElement.saving) {
                  <p-progressSpinner
                    styleClass="w-1rem h-1rem"
                    strokeWidth="6"
                    animationDuration="1s"
                  />
                }
              </div>

              <!-- </div> -->
            </div>
          </div>
        }
        <!-- TRACKED ITEM -->
        @if (selectedElement && selectedElement.related_tracked_item?.uuid) {
          <div
            class="col-lg-6 d-flex"
            style="flex-shrink: 0; flex-basis: 50%; height: 100%"
          >
            <div class="task-panel">
              <div class="task-panel-head">
                <div class="left">
                  <textarea
                    class="title"
                    autosize
                    rows="1"
                    maxRows="3"
                    [attr.contenteditable]="false"
                    ngDefaultControl
                    [(ngModel)]="selectedElement.name"
                    (keypress)="keyHandler($event)"
                    (paste)="onPaste($event)"
                    placeholder="Insert the task title"
                    (blur)="
                      selectedElement.type == 'task'
                        ? onBlur(selectedElement, task_group)
                        : onBlur(selectedElement)
                    "
                  >
                    {{ selectedElement?.name }}
                  </textarea>
                </div>
                @if (selectedElement.type == "task") {
                  <div class="right" style="position: relative" dropdown>
                    @if (
                      selectedElement?.related_tracked_item?.answer_status ===
                      "draft"
                    ) {
                      <div class="icon" dropdownToggle>
                        <span
                          id="taskDropdownActions"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="feather more-horizontal"></i>
                        </span>
                        <ul
                          *dropdownMenu
                          class="dropdown-menu dropdown-menu-end"
                          aria-labelledby="taskDropdownActions"
                        >
                          <li class="dropdown-header" style="padding: 3px 13px">
                            TASK ACTIONS
                          </li>
                          <li
                            role="menuitem"
                            (click)="openRemoveTaskModal(removeTaskModal)"
                          >
                            <a>Remove</a>
                          </li>
                          @if (selectedElement.related_tracked_item != null) {
                            <li
                              role="menuitem"
                              (click)="
                                launchAdvancedEdit(
                                  selectedElement.related_tracked_item
                                )
                              "
                            >
                              <a>Edit</a>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="fake-client-task">
                <tracked-item-bubble
                  [tracked_item]="selectedElement?.related_tracked_item"
                  [user]="sharedDataService.user"
                  [company]="job?.client_company"
                  [conversation]="{
                    id: selectedElement?.related_tracked_item.conversation,
                  }"
                  [shouldOpenDrawer]="
                    selectedElement?.related_tracked_item.is_draft
                      ? false
                      : true
                  "
                  [isPreview]="true"
                ></tracked-item-bubble>
              </div>
              @if (canShowPublishButton() && !templateManager) {
                <div>
                  <button
                    class="btn btn-success"
                    (click)="publishTrackedItem()"
                    [disabled]="
                      !selectedElement?.related_tracked_item?.is_draft
                    "
                  >
                    Create this Client Task
                  </button>
                </div>
              } @else {
                @if (!templateManager) {
                  <div>
                    <span style="font-size: 0.8em">
                      This task will be automatically created in the Client
                      Workspace
                      {{ autopilotIn }} days before the start date shown above.
                    </span>
                  </div>
                }
              }
              <!-- </div> -->
            </div>
          </div>
        }
        <!-- TRACKED ITEM -->
      </div>
    </div>
  }
</div>

<div class="job-right-panel">
  @if (job != null && job.uuid?.length > 7 && !templateManager) {
    <div [ngClass]="{ 'component-loading': isTrackingTime == null }">
      @if (!isTrackingTime) {
        <h4>Time Tracking</h4>
      }
      @if (isTrackingTime) {
        <h4 class="timeTrackingTitle">
          Time Tracking
          <div
            class="timeTrackingTitle"
            style="display: inline"
            [ngStyle]="{ color: timerService.isPaused ? '#959DAB' : 'black' }"
          >
            {{ timerService.formattedTime() }}
          </div>
        </h4>
      }
      @if (!hasCompletedTracking && !isTrackingTime) {
        <div class="timeTrackingTitle" style="font-size: 14px">
          <i class="feather clock"></i>
          No time tracked yet
        </div>
      }
      @if (hasCompletedTracking) {
        <div class="timeTrackingTitle" style="font-size: 14px">
          <i class="feather clock"></i>
          Total time tracked: {{ totalTimeTracked }}
        </div>
      }
      @if (!isTrackingTime) {
        <div class="buttons-container">
          <button
            class="btn btn-success normalStartButton"
            (click)="openTimeTrackingModal(job.client_company, job, user.id)"
          >
            <i class="tio-play" style="font-size: 20px !important"></i>
            Start tracking
          </button>
          <button
            class="btn btn-primary historyButton"
            (click)="openTimeTrackingDetailsModal()"
          >
            <i class="tio-remaining_time" style="font-size: 16px"></i>
            Time entries
          </button>
        </div>
      }
      @if (isTrackingTime) {
        <div class="buttons-container">
          @if (!timerService.isPaused) {
            <button
              class="btn btn-primary timerButtons"
              style="margin-right: 6px; width: 90px"
              (click)="timerPause()"
            >
              <i class="tio-pause" style="font-size: 20px"></i>
              Pause
            </button>
          }
          @if (timerService.isPaused) {
            <button
              class="btn btn-primary timerButtons"
              style="margin-right: 6px"
              (click)="timerResume()"
            >
              <i class="tio-play" style="font-size: 20px"></i>
              Resume
            </button>
          }
          <button
            class="btn btn-primary timerButtons"
            style="margin-right: 6px; background-color: red; width: 90px"
            (click)="openStopConfirmationModal()"
          >
            <i class="tio-stop" style="font-size: 20px"></i>
            Stop
          </button>
          <button
            class="btn btn-primary timerButtons"
            (click)="openTimeTrackingDetailsModal()"
            style="flex-grow: 1"
          >
            <i class="tio-remaining_time" style="font-size: 16px"></i>
            Time entries
          </button>
        </div>
      }
    </div>
  }
  @if (job != null && job.uuid?.length > 7 && !templateManager) {
    <div>
      <hr style="border-width: 2px" />
    </div>
  }

  <h4>Attachments</h4>
  <app-job-upload-file
    [job]="job"
    style="margin-bottom: 0"
  ></app-job-upload-file>
  <div>
    <hr style="border-width: 2px" />
  </div>

  <!-- Comments -->

  @if (!templateManager) {
    <h4>Comments</h4>
    <div class="left-form jobs-comment">
      <div
        class="jobs-comment-wrapper"
        #jobsCommentWrapper
        id="jobsCommentWrapper"
      >
        <div class="jobs-comment-wrapper-wrapper">
          <!-- It would be cool if the loading was only within this div -->
          @if (commentsLoading) {
            <div class="loading">
              <div class="loader">Loading...</div>
            </div>
          }
          @for (comment of comments; track comment.uuid) {
            <div class="message-bubble">
              @if (isSender(comment)) {
                <div class="message-actions">
                  <span
                    dropdown
                    container="body"
                    #dropdown="bs-dropdown"
                    [autoClose]="true"
                  >
                    <span id="dLabel" type="button" dropdownToggle>
                      <i class="feather more-horizontal"></i>
                    </span>
                    <ul
                      aria-labelledby="dLabel"
                      id="dropdown-triggers-manual"
                      *dropdownMenu
                      class="dropdown-menu tag-add-dropdown-menu"
                      role="menu"
                      aria-labelledby="button-triggers-manual"
                    >
                      @if (canDelete(comment)) {
                        <li>
                          <a (click)="toggleMessageVisibility(comment)"
                            ><i class="feather trash-2"></i> Delete</a
                          >
                        </li>
                      }
                      @if (canEdit(comment)) {
                        <li>
                          <a (click)="editMessage(comment)"
                            ><i class="feather edit"></i> Edit</a
                          >
                        </li>
                      }
                      @if (canRestore(comment)) {
                        <li>
                          <a (click)="toggleMessageVisibility(comment)"
                            ><i class="feather rotate-ccw"></i> Restore</a
                          >
                        </li>
                      }
                    </ul>
                  </span>
                </div>
              }
              <div
                class="message-bubble-wrapper"
                [ngClass]="{ me: comment.sent_by?.id === user.id }"
              >
                <div class="message-bubble-header">
                  <div class="name">
                    {{
                      comment.sent_by?.id === user.id
                        ? "You"
                        : comment.sent_by?.full_name
                    }}
                  </div>
                  @if (comment.created_date) {
                    <div
                      class="date"
                      tooltip="{{
                        message.created_date
                          | amFromUtc
                          | amLocal
                          | amDateFormat: 'MMM, Do YYYY, h:mm A'
                      }}"
                    >
                      {{
                        comment.created_date
                          | amCalendar: referenceTime : formats
                      }}
                    </div>
                  } @else {
                    <div class="date">🕒</div>
                  }
                  @if (comment.recipients?.length > 0) {
                    <div
                      class=""
                      tooltip="{{ getNotifiedUsersByComment(comment) }}"
                      data-html="true"
                      style="
                        margin-left: 5px;
                        font-size: 0.8em;
                        white-space: pre-wrap;
                      "
                    >
                      <i class="feather bell"></i>
                    </div>
                  }
                </div>
                @if (comment.edit_mode ?? false) {
                  <textarea
                    style="
                      border: none !important;
                      outline: none !important;
                      box-shadow: none !important;
                      padding: 0 !important;
                    "
                    class="form-control chat-input in-message-edit"
                    rows="1"
                    autosize
                    #inputMessage
                    [(ngModel)]="comment.text"
                    autofocus
                    placeholder="Type a message..."
                  ></textarea>
                  <button
                    class="btn btn-light"
                    style="margin-right: 5px"
                    (click)="editMessageConfirm(comment)"
                  >
                    <i class="feather check"></i> Save
                  </button>
                  <button (click)="cancelEdit(comment)" class="btn btn-primary">
                    Cancel
                  </button>
                } @else {
                  @if (!(comment.is_deleted ?? false)) {
                    {{ comment.text }}
                    @if (comment.is_edited ?? false) {
                      <p class="edited-message">(edited)</p>
                    }
                  } @else {
                    <p class="deleted-message">This message has been deleted</p>
                  }
                }
              </div>
            </div>
          }
        </div>
        <!-- </div> -->

        <div
          class="chat-input-wrapper"
          [ngClass]="{ 'no-text': message === '' }"
        >
          <textarea
            name="message"
            class="form-control chat-input"
            rows="1"
            [mention]="accountants"
            [mentionConfig]="{
              triggerChar: '@',
              maxItems: 10,
              dropUp: true,
              labelKey: 'full_name',
              allowSpace: true,
            }"
            (itemSelected)="selectUserToNotify($event)"
            (keydown.enter)="$event.preventDefault(); comment()"
            [(ngModel)]="message"
            autofocus
            autosize
            placeholder="Type a message. Shift+Enter adds a line."
            #taChatInput
            id="taChatInput"
            rows="1"
          ></textarea>
          <div
            class="d-flex align-items-center top-0 bottom-0"
            (click)="toggleAccountants()"
            #toggleButtonBellMenu
          >
            <i
              class="tio-notifications fs-4"
              style="
                position: absolute;
                right: 50px;
                bottom: 25px;
                cursor: pointer;
              "
            ></i>
            @if (getSelectedAccountantsCount() > 0) {
              <label
                style="
                  color: white;
                  font-weight: 700;
                  font-size: 0.7em;
                  background-color: red;
                  text-align: center;
                  border-radius: 10px;
                  width: 15px;
                  position: absolute;
                  right: 47px;
                  bottom: 25px;
                "
              >
                {{ getSelectedAccountantsCount() }}
              </label>
            }
          </div>
          <i
            class="tio-send send animated infinite d-flex align-items-center pe-3"
            style="bottom: 20px"
            (click)="comment()"
          ></i>
        </div>

        @if (showAccountants) {
          <div
            #bellMenu
            class="bell-menu"
            style="
              background-color: white;
              border-radius: 10px;
              border: 1px solid #ebebeb;
              position: absolute;
              bottom: 52px;
              right: 0;
            "
          >
            <div
              style="
                background-color: #f7f7f7;
                border-bottom: 1px solid #ebebeb;
                border-radius: 4px;
                width: 100%;
                padding: 15px 10px 5px 10px;
                clear: both;
              "
            >
              Notify the following users:
            </div>
            <div>
              @for (acc of accountants; track acc; let i = $index) {
                <div
                  style="
                    display: flex;
                    border-bottom: 1px solid #ebebeb;
                    padding: 5px 5px 5px 10px;
                  "
                  (click)="acc.selected = !acc.selected"
                >
                  <div>
                    <input
                      type="checkbox"
                      [checked]="acc.selected"
                      name="check{{ acc.id }}"
                      id="check{{ acc.id }}"
                    />
                  </div>
                  <div style="margin-left: 10px">
                    {{ acc.full_name }}
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  <!-- Comments -->

  <!-- Mark as completed modal -->
  <ng-template #completedConfirmation>
    <div
      class="modal-body text-center"
      style="
        box-shadow: 0 0 0 9999px rgba(30, 35, 40, 0.5);
        border-radius: 8px;
        background: #fff;
      "
    >
      <p>
        {{
          job.recurring
            ? "All tasks are completed. Do you want to mark the Job as Completed and create the next instance of this job?"
            : "All tasks are complete. Do you want to mark this job as Completed?"
        }}
      </p>
      <button type="button" class="btn btn-primary" (click)="markAsCompleted()">
        Yes
      </button>
      <button
        type="button"
        class="btn btn-default"
        (click)="bsModalRef.hide()"
        style="margin-left: 15px"
      >
        No
      </button>
    </div>
  </ng-template>

  <!-- Mark as in-progress modal -->
  <ng-template #markAsInProgressModal>
    <div
      class="modal-body text-center"
      style="background: #fff; border-radius: 16px"
    >
      <p>Do you want to move the Job Status to In Progress?</p>
      <button
        type="button"
        class="btn btn-primary"
        (click)="markAsInProgress()"
      >
        Yes
      </button>
      <button
        type="button"
        class="btn btn-default"
        (click)="bsModalRef.hide()"
        style="margin-left: 15px"
      >
        No
      </button>
    </div>
  </ng-template>

  <ng-template #duplicateJobModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">
        {{ !templateManager ? "Duplicate" : "Copy" }} Job
      </h4>
    </div>
    <div class="modal-body text-center">
      <i class="feather clipboard x3" style="color: #0075ff"></i>
      <h4>Choose the workspace where this Job should be added:</h4>
      <input
        [(ngModel)]="duplicateSelected"
        (typeaheadOnSelect)="selectClient($event)"
        [typeahead]="dashboardStore.clients | activeClientsOnly"
        typeaheadOptionField="name"
        [typeaheadOptionsLimit]="9999"
        [typeaheadMinLength]="0"
        placeholder="Choose a workspace"
        class="form-control"
      />
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default pull-left"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
      <button
        class="btn btn-primary pull-right"
        [disabled]="duplicateSelected == null || duplicateSelected == ''"
        (click)="duplicateJob()"
      >
        Create Job
      </button>
    </div>
  </ng-template>

  <ng-template #createJobModal id="createJobModal">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Create Job</h4>
    </div>
    <div class="modal-body text-center create-job-modal">
      <i class="feather clipboard x3" style="color: #0075ff"></i>
      <h4>Choose the workspace where this Job should be added:</h4>
      <input
        [(ngModel)]="duplicateSelected"
        (typeaheadOnSelect)="selectClient($event)"
        [typeahead]="dashboardStore.clients | activeClientsOnly"
        typeaheadOptionField="name"
        [typeaheadOptionsLimit]="9999"
        [typeaheadMinLength]="0"
        placeholder="Choose a workspace"
        class="form-control"
      />

      <div class="row text-left">
        <div class="col-md-12">
          @if (jobsStore.company.accountants != null) {
            <div class="form-group assignee-wrapper">
              <label style="margin-top: 15px">Assignee</label>
              <div class="assignee" dropdown [autoClose]="true" dropdownToggle>
                <div class="avatar">
                  <img
                    [src]="
                      job.assigned_to?.pictureUrl ??
                      'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                    "
                  />
                </div>
                <div
                  class="username"
                  [tooltip]="
                    job.assigned_to == null
                      ? 'Assign to'
                      : job.assigned_to?.full_name
                  "
                  placement="top"
                >
                  {{
                    job.assigned_to == null
                      ? "Assign to"
                      : job.assigned_to?.full_name
                  }}
                </div>
                <ul
                  id="basic-link-dropdown"
                  *dropdownMenu
                  class="dropdown-menu"
                  role="menu"
                  aria-labelledby="basic-link"
                >
                  @for (accountant of _accountants; track accountant) {
                    <li (click)="selectTemplateAssignee(accountant)">
                      <a>
                        <div class="avatar">
                          <img
                            [src]="
                              accountant.user.pictureUrl ??
                              'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                            "
                          />
                        </div>
                        <div
                          class="username"
                          [tooltip]="accountant.user.full_name"
                          placement="top"
                        >
                          {{ accountant.user.full_name }}
                        </div>
                      </a>
                    </li>
                  }
                </ul>
                <i class="feather chevron-down"></i>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="row text-left">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Start date</label>

                <p-datepicker
                  [(ngModel)]="job.target_start_date"
                  [dateFormat]="datepickerFormat"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Due date</label>
                <p-datepicker
                  [(ngModel)]="job.due_date"
                  [dateFormat]="datepickerFormat"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default pull-left"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
      <button
        class="btn btn-primary pull-right"
        [disabled]="
          duplicateSelected == null ||
          duplicateSelected == '' ||
          !job.assigned_to
        "
        (click)="
          duplicateJob({
            target_start_date: job.target_start_date,
            due_date: job.due_date,
            assigned_to_id: job.assigned_to.id,
          })
        "
      >
        Create Job
      </button>
    </div>
  </ng-template>

  <ng-template #removeJobModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Remove Job</h4>
    </div>
    @if (
      job.recurring && job.recurrence_options["type"] != RECURRENCE_TYPES.DAILY
    ) {
      <div class="modal-body text-center">
        <i class="feather trash-2 x3" style="color: #bd1105"></i>
        <h4>This is a Recurring Job.<br />Do you want to:</h4>
        <p>
          Delete this instance of the Job but create a new instance for the next
          due date:
        </p>
        <div class="btn btn-warning btn-block" (click)="deleteJob(true)">
          Delete this and create next
        </div>
        <hr />
        <p>Delete this job without creating a new instance</p>
        <p>
          ⚠️ Caution: If this is the only instance of the Job, deleting will
          delete your process: tasks and task details etc.
        </p>
        <div class="btn btn-danger btn-block" (click)="deleteJob(false)">
          Delete instance
        </div>
      </div>
    }

    @if (
      job.recurring &&
      job.recurrence_options["type"] == RECURRENCE_TYPES.DAILY &&
      job.is_recurring_master
    ) {
      <div class="modal-body text-center">
        <i class="feather trash-2 x3" style="color: #bd1105"></i>
        <h4>This is a Daily Recurring Job.<br />Do you want to:</h4>
        <p>Delete this instance of the Job</p>
        <div class="btn btn-warning btn-block" (click)="deleteJob(false)">
          Delete this
        </div>
        <hr />
        <p>Delete this job and future instances already created from this</p>
        <div class="btn btn-danger btn-block" (click)="deleteJob(true)">
          Delete instance and its children
        </div>
      </div>
    }

    @if (
      !job.recurring ||
      (job.recurring &&
        job.recurrence_options["type"] == RECURRENCE_TYPES.DAILY &&
        !job.is_recurring_master)
    ) {
      <div class="modal-body text-center">
        <i class="feather trash-2 x3" style="color: #bd1105"></i>
        <p>
          <strong
            >This will delete the entire job, including all tasks and task
            details!</strong
          >
        </p>
        <p>Are you sure you want to delete this job?</p>
        <div class="btn btn-danger btn-block" (click)="deleteJob(false)">
          Delete Job
        </div>
      </div>
    }
    <div class="modal-footer">
      <div
        class="btn btn-default btn-block"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
    </div>
  </ng-template>

  <ng-template #removeTemplateModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Remove Template</h4>
    </div>
    <div class="modal-body text-center">
      <i class="feather trash-2 x3" style="color: #bd1105"></i>
      <p>Are you sure you want to delete this template?</p>
      <div class="btn btn-danger btn-block" (click)="deleteJob(false)">
        Delete template
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default btn-block"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
    </div>
  </ng-template>

  <ng-template #removeTaskModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Remove Task</h4>
    </div>
    <div class="modal-body text-center">
      <i class="feather trash-2 x3" style="color: #bd1105"></i>
      <p>Are you sure you want to delete this task?</p>
      <div
        class="btn btn-danger btn-block"
        (click)="deleteTask(selectedElement)"
      >
        Delete Task
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default btn-block"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
    </div>
  </ng-template>

  <ng-template #removeTaskGroupModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Remove Task Group</h4>
    </div>
    <div class="modal-body text-center">
      <i class="feather trash-2 x3" style="color: #bd1105"></i>
      <p>
        Are you sure you want to remove this task group? All tasks within this
        group will also be deleted.
      </p>
      <div
        class="btn btn-danger btn-block"
        (click)="deleteTaskGroup(selectedElement)"
      >
        Remove
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default btn-block"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
    </div>
  </ng-template>

  <ng-template #repeatModal class="edit-rules-modal-wrapper">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="cancelRepeatModal(job.recurrence_options)"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Edit repeat rules</h4>
    </div>

    <div class="modal-body" style="overflow: visible">
      <span style="margin-bottom: 5px; display: block">
        <span style="margin-right: 10px; font-weight: 600; color: #151c29"
          >Recur by:</span
        >

        <!-- <label style="font-weight: normal; margin-right: 15px">
          <input
            type="radio"
            name="12312321"
            [(ngModel)]="job.recurrence_options['type']"
            [value]="3"
          />
          Day
        </label> -->

        <label style="font-weight: normal; margin-right: 15px">
          <input
            type="radio"
            name="12312321"
            [(ngModel)]="job.recurrence_options['type']"
            [value]="0"
          />
          Week
        </label>

        <label style="font-weight: normal">
          <input
            type="radio"
            name="12312321"
            [(ngModel)]="job.recurrence_options['type']"
            [value]="1"
          />
          Month
        </label>

        <!-- <select style="width: 110px; display: inline" name="12312321" id="recurrence_type"
                    [(ngModel)]="job.recurrence_options['type']"  class="form-control">
                    <option value="0">Weekly</option>
                    <option value="1">Monthly</option>
                  </select> -->
      </span>

      @if (job.recurrence_options["type"] == 0) {
        <span style="display: block">
          <span style="padding: 10px; padding-left: 0">Every</span>
          <select
            style="width: 70px; display: inline"
            id="recurrence_weekly_weeks"
            [(ngModel)]="job.recurrence_options['weekly_weeks']"
            class="form-control"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
          <span style="padding: 10px">weeks due on</span>
          <select
            style="width: 90px; display: inline"
            name="recurrence_weekly_day"
            [(ngModel)]="job.recurrence_options['weekly_day']"
            id="recurrence_weekly_day"
            class="form-control"
          >
            <option value="0">Mon</option>
            <option value="1">Tue</option>
            <option value="2">Wed</option>
            <option value="3">Thu</option>
            <option value="4">Fri</option>
            <option value="5">Sat</option>
            <option value="6">Sun</option>
          </select>
        </span>
      }
      @if (job.recurrence_options["type"] == 1) {
        <span class="" style="display: block">
          <span style="padding: 10px; padding-left: 0">Every</span>
          <select
            style="width: 90px; display: inline"
            name="recurrence_monthly_months"
            id="recurrence_monthly_months"
            [(ngModel)]="job.recurrence_options['monthly_months']"
            class="form-control"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
          </select>
          <span style="padding: 10px">months due on</span>
          <select
            style="width: 90px; display: inline; margin-right: 10px"
            class="form-control"
            [(ngModel)]="job.recurrence_options['monthly_day']"
          >
            @for (item of [].constructor(31); track item; let i = $index) {
              <option [value]="i + 1">
                {{ i + 1 }}
              </option>
            }
          </select>
          <span>date</span>
          <i
            class="feather info"
            style="
              font-size: 22px;
              margin-left: 3px;
              padding: 5px;
              vertical-align: -3px;
            "
            tooltip="For the last date of each month, choose 31."
          ></i>
        </span>
      }
      @if (
        job.recurrence_options["type"] != 0 &&
        job.recurrence_options["type"] != 3
      ) {
        <div style="margin: 15px 0; display: flex; gap: 4px">
          <label class="task-checkbox" style="margin-top: 2px">
            <input
              type="checkbox"
              [(ngModel)]="job.recurrence_options['adjust_due_date']"
              id="adjust_due_date"
            />
            <div class="custom-checkbox"></div>
          </label>
          <span class="text" style="margin-left: 5px"
            >Adjust due date to prior Friday, if due date falls on weekend</span
          >
        </div>
      }

      @if (job.recurrence_options["type"] != 3) {
        <span class="" style="display: block; margin: 15px 0">
          <span>Set start date to be</span>
          <select
            style="width: 90px; display: inline; margin: 0 10px"
            class="form-control"
            [(ngModel)]="job.recurrence_options['adjust_start_date']"
          >
            @for (item of [].constructor(181); track i; let i = $index) {
              <option [value]="i">
                {{ i }}
              </option>
            }
          </select>
          <span>days before due date.</span>
        </span>
      }

      @if (job.recurrence_options["type"] == 3) {
        <p>
          Before setting the Daily recurrence option, make sure your Job has all
          the necessary tasks created. Once you save it, the system will
          automatically create the jobs for this week and for every week
          onwards.
        </p>
      }

      @if (jobsStore.company.accountants != null) {
        <div
          class="form-group assignee-wrapper assignee-on-modal"
          style="display: flex; justify-content: normal"
        >
          <div
            style="
              margin-top: 15px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <label>Start each recurring job with owner: </label>
            <div
              class="assignee"
              dropdown
              [autoClose]="true"
              dropdownToggle
              style="margin-left: 20px"
            >
              <div class="avatar">
                <img
                  [src]="
                    job.starting_owner?.pictureUrl ??
                    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                  "
                />
              </div>
              <div
                class="username"
                [tooltip]="
                  job.starting_owner == null
                    ? 'Assign to'
                    : job.starting_owner?.full_name
                "
                placement="top"
              >
                {{
                  job.starting_owner == null
                    ? "Assign to"
                    : job.starting_owner?.full_name
                }}
              </div>
              <ul
                id="basic-link-dropdown"
                *dropdownMenu
                class="dropdown-menu"
                role="menu"
                aria-labelledby="basic-link"
                style="top: none; left: none"
              >
                @for (accountant of _accountants; track accountant) {
                  <li (click)="selectJobStartingOwner(accountant)">
                    <a>
                      <div class="avatar">
                        <img
                          [src]="
                            accountant.user.pictureUrl ??
                            'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                          "
                        />
                      </div>
                      <div
                        class="username"
                        [tooltip]="accountant.user.full_name"
                        placement="top"
                      >
                        {{ accountant.user.full_name }}
                      </div>
                    </a>
                  </li>
                }
              </ul>
              <i class="feather chevron-down"></i>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default pull-left"
        aria-label="Cancel"
        (click)="cancelRepeatModal(job.recurrence_options)"
      >
        Cancel
      </div>
      <button
        class="btn btn-primary pull-right"
        (click)="saveOrCreateByJob(job); bsModalRef.hide()"
        [disabled]="!checkRepeatIsValid(job.recurrence_options)"
      >
        Save
      </button>
    </div>
  </ng-template>

  <ng-template #reassignJobModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="reassignModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Reassign Job</h4>
    </div>
    <div class="modal-body text-center">
      <p>
        Do you want to re-assign the job to
        {{ reassignModalRef.content.user.full_name }}?
      </p>
      <div
        class="btn btn-danger btn-block"
        (click)="reassignJob(job, reassignModalRef.content.user)"
      >
        Reassign
      </div>
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default btn-block"
        aria-label="Cancel"
        (click)="reassignModalRef.hide()"
      >
        Cancel
      </div>
    </div>
  </ng-template>

  <ng-template #historyModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Job History</h4>
    </div>
    <div class="modal-body text-left" style="background-color: white">
      @for (h of bsModalRef.content.history; track h) {
        <div>
          [{{
            h.action_dt
              | amFromUtc
              | amLocal
              | amDateFormat: "MMM, Do YYYY, h:mm A"
          }}]
          {{ h.user }}
          <strong class="action {{ h.action_style }}">{{
            h.action_verbose
          }}</strong
          >&nbsp; <strong>{{ h.object_name }}</strong
          >&nbsp;
          @for (change of h.differences; track change) {
            <div style="margin-left: 10px">
              <span>{{ change.field }}: </span>
              <span
                [innerHTML]="
                  change.before
                    | historyFormatter: change.field + '=>' + change.after
                    | historyFormatter: change.field
                "
              >
                ></span
              ><br />
            </div>
          }
        </div>
      }
      @if (bsModalRef.content.history.length == 0) {
        <span>No history events have been tracked for this job</span>
      }
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default btn-block"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Close
      </div>
    </div>
  </ng-template>
</div>
